import { ActionTypeKeys, ActionTypes } from 'common/actions'

export const initialWaypointsState: WaypointsState = {
  automatedScrolling: false,
  childRect: undefined,
  parentRect: undefined,
  seen: {},
}

export interface WaypointsState {
  automatedScrolling: boolean
  childRect?: {
    bottom: number
    height: number
    left: number
    right: number
    top: number
    width: number
  }
  parentRect?: {
    height: number
    width: number
  }
  seen: {
    [key: string]: boolean
  }
}

const reducer = (state: WaypointsState = initialWaypointsState, action: ActionTypes): WaypointsState => {
  switch (action.type) {
    case ActionTypeKeys.VIEWPORT_UPDATE:
      return {
        ...state,
        childRect: action.childRect,
        parentRect: action.parentRect,
        automatedScrolling: action.automatedScrolling,
      }
    case ActionTypeKeys.WAYPOINT_SEEN:
      return { ...state, seen: { ...state.seen, [action.name]: true } }
    default:
      return state
  }
}

export default reducer
